import { IntegrationsConfig } from "types/IntegrationConfig";
import { ACCOUNTING_PERMISSIONS } from "pages/pmt/integrations/constants";
import quickbooksLogo from "pages/pmt/integrations/images/integration-partner-logos/quickbooks-logo.svg";

// Quickbooks uses a separate PDP and setup flow. Only the marketplaceCard is used from this file.
export const quickbooksConfig: IntegrationsConfig = {
  numAllowedInstances: 1,
  copy: {
    marketplaceCard: {
      logoUrl: quickbooksLogo,
      integrationName: "QuickBooks Online",
      integrationDescription:
        "Easily sync your payroll and expenses with Justworks",
      integrationCategory: "Accounting",
      requiredPermissions: ACCOUNTING_PERMISSIONS,
      slug: "quickbooks-online",
      pdpUrl: "/quickbooks_online/v3/settings",
    },
    pdp: {
      headerDescription: "",
      heroImageUrl: "",
      horizontalLogoUrl: "",
      resourceCard: {
        links: [],
      },
      infoTabsConfig: {},
      infoTabsContent: {
        overviewTab: {
          header: "",
          subheader: "",
          list: [
            {
              summary: "",
              detail: "",
            },
          ],
        },
      },
      disconnectModalContent: {
        title: "",
        body: <div></div>,
        disconnectButtonText: "",
      },
      allowedPdpActions: [],
    },
    setup: {
      estimatedSetupTime: "",
      helpCenterLink: "",
      stepperConfig: {},
      steps: [],
      instanceKeys: [],
      getCurrentStepFunction: () => 0,
    },
  },
};
